<template>
  <van-swipe v-if="slidesList && slidesList.length > 0" class="my-swipe mt-52p" :autoplay="3000" indicator-color="white">
    <van-swipe-item v-for="item in slidesList" :key="item.id">
      <div @click="goPage(item)" class="banner-img" :style="{backgroundImage: 'url('+uploadresUrl+item.imageUrl+')'}">
        <div class="carousel-caption banner-content py-0">
          <div class="banner-title van-multi-ellipsis--l2">{{item.title}}</div>
        </div>
      </div>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
  import Vue from 'vue';
  import {Swipe, SwipeItem, Button} from 'vant';
  import {mapState} from "vuex";

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  Vue.use(Button);


  export default {
    name: "swipeComponent",
    props: ['slidesList'],
    data() {
      return {
        shiyong: false
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        ContentTypeEnum: state => state.ContentTypeEnum
      })
    },
    methods: {
      goPage(item) {
        if (item.contentType === this.ContentTypeEnum.PROJECT.value
          || item.contentType === this.ContentTypeEnum.COURSE.value) {
          this.$router.push('/'+item.contentType+'/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.USER.value) {
          this.$router.push('/lecturer/'+item.content);
        }
        if (item.contentType === this.ContentTypeEnum.NEWS.value) {
          this.$router.push('/news-detail/'+item.id);
        }
        if (item.contentType === this.ContentTypeEnum.LINK.value) {
          window.open(item.linkUrl);
        }

      }
    }
  }
</script>

<style scoped>
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    text-align: center;
  }
</style>
